import type { Municipality } from '@/types'
import LoadingBox from '@/components/loading-box'
import ErrorBox from '@/components/error-box'
import { useMunicipalitiesPublic } from '@/hooks/api/use-municipality'

interface MunicipalitiesPublicLoaderProps {
    children: (data: Array<Municipality> ) => React.ReactNode
}

const MunicipalitiesPublicLoader: React.FC<MunicipalitiesPublicLoaderProps> = ({
    children,
}) => {

    const { status, data, error } = useMunicipalitiesPublic()

    if (status === 'pending') {
        return <LoadingBox />
    }

    if (error) {
        return <ErrorBox
            error={error}
            message={'Nepovedlo se načíst obce'}
        />
    }


    if (data.length > 0) {
        return <>{children(data)}</>
    }

    return <>{children([])}</>
}

export default MunicipalitiesPublicLoader
